const IlustracaoLogin = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 800 900"
    preserveAspectRatio="xMidYMid meet"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <radialGradient id="brilho1" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#4f8ef7" stopOpacity="0.18" />
        <stop offset="100%" stopColor="#4f8ef7" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="brilho2" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#93c5fd" stopOpacity="0.12" />
        <stop offset="100%" stopColor="#93c5fd" stopOpacity="0" />
      </radialGradient>
    </defs>
    <ellipse cx="200" cy="300" rx="260" ry="220" fill="url(#brilho1)" />
    <ellipse cx="650" cy="650" rx="200" ry="180" fill="url(#brilho2)" />
    <circle cx="120" cy="160" r="2.5" fill="#93c5fd" opacity="0.4" />
    <circle cx="340" cy="90" r="1.8" fill="#bfdbfe" opacity="0.35" />
    <circle cx="580" cy="200" r="2" fill="#93c5fd" opacity="0.3" />
    <circle cx="700" cy="120" r="1.5" fill="#bfdbfe" opacity="0.4" />
    <circle cx="60" cy="420" r="2" fill="#93c5fd" opacity="0.25" />
    <circle cx="760" cy="380" r="2.5" fill="#bfdbfe" opacity="0.3" />
    <circle cx="420" cy="460" r="1.5" fill="#93c5fd" opacity="0.2" />
    <circle cx="680" cy="500" r="2" fill="#bfdbfe" opacity="0.25" />
    <line
      x1="0"
      y1="820"
      x2="800"
      y2="820"
      stroke="#3b5fc0"
      strokeWidth="1"
      opacity="0.3"
    />
    <line
      x1="0"
      y1="840"
      x2="800"
      y2="840"
      stroke="#3b5fc0"
      strokeWidth="1"
      opacity="0.2"
    />
    <line
      x1="0"
      y1="860"
      x2="800"
      y2="860"
      stroke="#3b5fc0"
      strokeWidth="1"
      opacity="0.15"
    />
    <rect
      x="380"
      y="710"
      width="420"
      height="18"
      rx="4"
      fill="#1e3a8a"
      opacity="0.7"
    />
    <rect
      x="560"
      y="640"
      width="10"
      height="72"
      rx="3"
      fill="#1e40af"
      opacity="0.8"
    />
    <rect
      x="540"
      y="708"
      width="50"
      height="6"
      rx="2"
      fill="#1e40af"
      opacity="0.7"
    />
    <rect
      x="490"
      y="560"
      width="130"
      height="82"
      rx="6"
      fill="#1e3a8a"
      opacity="0.9"
    />
    <rect
      x="497"
      y="567"
      width="116"
      height="68"
      rx="3"
      fill="#2563eb"
      opacity="0.25"
    />
    <rect
      x="507"
      y="576"
      width="60"
      height="5"
      rx="2"
      fill="#93c5fd"
      opacity="0.5"
    />
    <rect
      x="507"
      y="586"
      width="42"
      height="4"
      rx="2"
      fill="#bfdbfe"
      opacity="0.3"
    />
    <rect
      x="507"
      y="594"
      width="50"
      height="4"
      rx="2"
      fill="#bfdbfe"
      opacity="0.25"
    />
    <rect
      x="507"
      y="602"
      width="35"
      height="4"
      rx="2"
      fill="#bfdbfe"
      opacity="0.2"
    />
    <rect
      x="572"
      y="610"
      width="10"
      height="18"
      rx="1"
      fill="#3b82f6"
      opacity="0.6"
    />
    <rect
      x="585"
      y="600"
      width="10"
      height="28"
      rx="1"
      fill="#60a5fa"
      opacity="0.5"
    />
    <rect
      x="598"
      y="606"
      width="10"
      height="22"
      rx="1"
      fill="#3b82f6"
      opacity="0.6"
    />
    <rect
      x="400"
      y="688"
      width="70"
      height="12"
      rx="2"
      fill="#1d4ed8"
      opacity="0.8"
    />
    <rect
      x="403"
      y="678"
      width="64"
      height="12"
      rx="2"
      fill="#2563eb"
      opacity="0.7"
    />
    <rect
      x="406"
      y="668"
      width="58"
      height="12"
      rx="2"
      fill="#3b82f6"
      opacity="0.6"
    />
    <line
      x1="400"
      y1="688"
      x2="400"
      y2="700"
      stroke="#93c5fd"
      strokeWidth="1"
      opacity="0.4"
    />
    <line
      x1="403"
      y1="678"
      x2="403"
      y2="690"
      stroke="#93c5fd"
      strokeWidth="1"
      opacity="0.4"
    />
    <rect
      x="485"
      y="706"
      width="52"
      height="5"
      rx="2"
      fill="#60a5fa"
      opacity="0.6"
    />
    <polygon points="537,706 537,711 544,708.5" fill="#93c5fd" opacity="0.7" />
    <rect
      x="660"
      y="682"
      width="28"
      height="30"
      rx="4"
      fill="#1e40af"
      opacity="0.8"
    />
    <path
      d="M688,692 Q700,692 700,704 Q700,716 688,716"
      stroke="#3b82f6"
      strokeWidth="3"
      fill="none"
      opacity="0.6"
    />
    <path
      d="M669,678 Q672,670 669,662"
      stroke="#93c5fd"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      opacity="0.4"
    />
    <path
      d="M676,676 Q679,668 676,660"
      stroke="#93c5fd"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      opacity="0.3"
    />
    <rect
      x="700"
      y="680"
      width="80"
      height="8"
      rx="3"
      fill="#1e3a8a"
      opacity="0.7"
    />
    <rect
      x="776"
      y="640"
      width="8"
      height="48"
      rx="2"
      fill="#1e3a8a"
      opacity="0.6"
    />
    <rect
      x="702"
      y="710"
      width="6"
      height="30"
      rx="2"
      fill="#1e3a8a"
      opacity="0.6"
    />
    <rect
      x="772"
      y="710"
      width="6"
      height="30"
      rx="2"
      fill="#1e3a8a"
      opacity="0.6"
    />
    <rect
      x="718"
      y="620"
      width="44"
      height="62"
      rx="8"
      fill="#1e40af"
      opacity="0.75"
    />
    <circle cx="740" cy="600" r="22" fill="#1e40af" opacity="0.75" />
    <path
      d="M718,650 Q700,660 695,690"
      stroke="#1e40af"
      strokeWidth="14"
      fill="none"
      strokeLinecap="round"
      opacity="0.75"
    />
    <path
      d="M762,650 Q775,660 778,688"
      stroke="#1e40af"
      strokeWidth="14"
      fill="none"
      strokeLinecap="round"
      opacity="0.75"
    />
    <rect
      x="105"
      y="590"
      width="50"
      height="75"
      rx="8"
      fill="#1e40af"
      opacity="0.6"
    />
    <circle cx="130" cy="572" r="24" fill="#1e40af" opacity="0.6" />
    <path
      d="M105,620 Q85,630 78,650"
      stroke="#1e40af"
      strokeWidth="14"
      fill="none"
      strokeLinecap="round"
      opacity="0.6"
    />
    <rect
      x="60"
      y="646"
      width="36"
      height="46"
      rx="3"
      fill="#2563eb"
      opacity="0.55"
    />
    <rect
      x="60"
      y="646"
      width="5"
      height="46"
      rx="2"
      fill="#1d4ed8"
      opacity="0.6"
    />
    <path
      d="M155,615 Q175,590 185,565"
      stroke="#1e40af"
      strokeWidth="13"
      fill="none"
      strokeLinecap="round"
      opacity="0.6"
    />
    <rect
      x="108"
      y="663"
      width="18"
      height="50"
      rx="5"
      fill="#1e3a8a"
      opacity="0.6"
    />
    <rect
      x="132"
      y="663"
      width="18"
      height="50"
      rx="5"
      fill="#1e3a8a"
      opacity="0.6"
    />
    <g transform="translate(290,130) rotate(-8)">
      <rect
        x="0"
        y="0"
        width="90"
        height="62"
        rx="4"
        fill="#1e40af"
        opacity="0.45"
      />
      <rect
        x="0"
        y="0"
        width="44"
        height="62"
        rx="4"
        fill="#2563eb"
        opacity="0.35"
      />
      <line
        x1="45"
        y1="0"
        x2="45"
        y2="62"
        stroke="#93c5fd"
        strokeWidth="1.5"
        opacity="0.5"
      />
      <line
        x1="8"
        y1="15"
        x2="38"
        y2="15"
        stroke="#bfdbfe"
        strokeWidth="2"
        opacity="0.4"
      />
      <line
        x1="8"
        y1="24"
        x2="38"
        y2="24"
        stroke="#bfdbfe"
        strokeWidth="2"
        opacity="0.3"
      />
      <line
        x1="8"
        y1="33"
        x2="30"
        y2="33"
        stroke="#bfdbfe"
        strokeWidth="2"
        opacity="0.25"
      />
      <line
        x1="52"
        y1="15"
        x2="82"
        y2="15"
        stroke="#bfdbfe"
        strokeWidth="2"
        opacity="0.4"
      />
      <line
        x1="52"
        y1="24"
        x2="82"
        y2="24"
        stroke="#bfdbfe"
        strokeWidth="2"
        opacity="0.3"
      />
      <line
        x1="52"
        y1="33"
        x2="74"
        y2="33"
        stroke="#bfdbfe"
        strokeWidth="2"
        opacity="0.25"
      />
    </g>
    <g transform="translate(560,140) rotate(5)" opacity="0.35">
      <rect x="0" y="0" width="110" height="44" rx="8" fill="#1e40af" />
      <text x="10" y="28" fontFamily="monospace" fontSize="16" fill="#93c5fd">
        E = mc²
      </text>
    </g>
    <g transform="translate(180,200)" opacity="0.4">
      <polygon points="30,0 60,14 30,28 0,14" fill="#2563eb" />
      <rect x="24" y="14" width="12" height="18" rx="2" fill="#1d4ed8" />
      <line
        x1="54"
        y1="14"
        x2="62"
        y2="30"
        stroke="#3b82f6"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <circle cx="62" cy="32" r="4" fill="#60a5fa" />
    </g>
    <g transform="translate(620,280)" opacity="0.35">
      <circle cx="20" cy="18" r="16" fill="#2563eb" />
      <path
        d="M14,24 Q14,32 20,32 Q26,32 26,24"
        stroke="#93c5fd"
        strokeWidth="2"
        fill="none"
      />
      <line
        x1="16"
        y1="34"
        x2="24"
        y2="34"
        stroke="#93c5fd"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="17"
        y1="38"
        x2="23"
        y2="38"
        stroke="#93c5fd"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="20"
        y1="2"
        x2="20"
        y2="6"
        stroke="#60a5fa"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="6"
        y1="8"
        x2="9"
        y2="11"
        stroke="#60a5fa"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="34"
        y1="8"
        x2="31"
        y2="11"
        stroke="#60a5fa"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export default IlustracaoLogin;
